<template>
  <div class="slide">
    <div class="soslogo">
      <img src="../assets/sos.png" />
    </div>
    <div class="centertext is-hidden-mobile" v-if="active">
      <div class="head title">
        SOS Lékárna <a href="https://www.sos-lekarna.cz/"><span class="has-text-weight-light has-text-primary">e-shop</span></a>
      </div>
      <div class="text">
        Pro potřeby e-shopu máme <span class="has-text-weight-bold">široké spektrum přípravků skladem</span>, zbytek zajišťujeme následující pracovní den. Nabízíme pestrou nabídku léčivých přípravků, vitamínů, doplňků stravy a zdravotnického materiálu. Samozřejmostí je nabídka kosmetiky a produktů podporujících zdravý životní styl. <span class="has-text-weight-bold">Přátelské</span>, ale i <span class="has-text-weight-bold">profesionální</span> jednání našich pracovnic, je zárukou spokojenosti zákazníků. <br><br>
        <span class="has-text-light has-background-dark p">&nbsp;&nbsp;Jsme k dispozici každý den od 8-15h&nbsp;&nbsp;</span>
      </div>
      <div class="buttons">
        <a href="https://www.sos-lekarna.cz/"><b-button type="is-dark"  icon-right="arrow-right" rounded>&nbsp;Přejít do e-shopu&nbsp;
        </b-button></a>
      </div>
    </div>
    <div class="centertextm is-hidden-tablet" v-if="active">
      <div class="headm title">
        SOS Lékárna <a href="https://www.sos-lekarna.cz/"><span class="has-text-weight-light has-text-primary">e-shop</span></a>
      </div>
      <div class="text">
        Pro potřeby e-shopu máme <span class="has-text-weight-bold">široké spektrum přípravků skladem</span>, zbytek
        zajišťujeme následující pracovní den. Nabízíme pestrou nabídku léčivých přípravků, vitamínů, doplňků stravy a
        zdravotnického materiálu. Samozřejmostí je nabídka kosmetiky a produktů podporujících zdravý životní styl. <span
          class="has-text-weight-bold">Přátelské</span>, ale i <span class="has-text-weight-bold">profesionální</span>
        jednání našich pracovnic, je zárukou spokojenosti zákazníků.<br><br>
        <span class="has-text-light has-background-dark p">&nbsp;&nbsp;Jsme k dispozici každý den od 8-15h&nbsp;&nbsp;</span>
      </div>
      <a href="https://www.sos-lekarna.cz/">
        <b-button type="is-dark" icon-right="arrow-right" expanded rounded>&nbsp;Přejít do e-shopu&nbsp;
        </b-button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutSOS',
  props: {
    active:Boolean
  }
}
</script>
<style scoped>
.p {
  padding: 5px;
}
.centertextm {
  margin-left: 50px;
  margin-right: 50px;
  text-align: center;
}
.soslogo
{
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: -6px;
}
.centertext {
  margin-left: 150px;
  max-width: 768px;
  margin-right: 150px;
}
.headm {
  -webkit-animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation-delay: 300ms;
  font-weight: bold;
  margin-top: 20px;
  color: black;
  font-size: 25px;
}
.buttons {
  -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation-delay: 1000ms;
}

.text {
  color: #252525;
  -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  margin-top: 20px;
  margin-bottom: 40px;
  animation-delay: 700ms;
}

.head {
  -webkit-animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation-delay: 300ms;
  font-weight: bold;
  margin-top: 20px;
  color: #252525;
  font-size: 45px;
}
.slide {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  background-image: url("../assets/back_l.jpg");

  -webkit-animation: bg-pan-left 28s infinite alternate both;
  animation: bg-pan-left 28s infinite alternate both;
}
 @media screen and (max-width: 768px) {

   .slide {
     display: block;
     padding-top: 5rem;

   }
 }
</style>
